import React from "react";
import Tick from "@/assets/icon/green-tick.svg";
import { isData, maskBankAcNum } from "@/utility/helperFunctions";
import { getBankLogo } from "@/utility/banks/banksConfig";

const BankDetails = ({ data }) => {
  const bankLogo = getBankLogo(data.bankIFSCNumber, data.bankName);

  return (
    <div className="tw-mt-4 tw-mb-5">
      <div className="tw-flex tw-gap-6 tw-items-center">
        <div className="tw-flex tw-items-center tw-gap-2">
          <div className="">
            <img
              alt=""
              className="tw-w-full tw-h-full"
              src={bankLogo}
            />
          </div>
          <div>
            <div className="tw-text-[14px] tw-text-primaryBlack tw-font-nmmed">
              {isData(data.bankName)}
            </div>
            <div className="tw-text-[12px] tw-text-customGray67 tw-font-nmmed">
              A/c: {maskBankAcNum(data.bankAccountNumber)}
            </div>
          </div>
        </div>
        {data.isPrimary && (
          <div className="tw-flex tw-items-center tw-gap-1">
            <div>
              <img alt="" src={Tick} />
            </div>
            <div className="tw-text-[12px] tw-text-[#29AD00] tw-font-nmmed">
              Primary
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default BankDetails;
